const PRICING_PERMISSION_CACHE_KEY = 'accountCanSeePricing';

const toBoolean = (value: string | null, fallback: boolean): boolean => {
  if (value === null) {
    return fallback;
  }
  return value === '1' || value === 'true';
};

export const readCachedPricingPermission = (fallback = false): boolean => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  try {
    const cachedValue =
      localStorage.getItem(PRICING_PERMISSION_CACHE_KEY) ??
      localStorage.getItem('subaccountCanSeePricing');
    return toBoolean(cachedValue, fallback);
  } catch (error) {
    return fallback;
  }
};

export const writeCachedPricingPermission = (canSeePricing: boolean): void => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(PRICING_PERMISSION_CACHE_KEY, canSeePricing ? '1' : '0');
  } catch (error) {
    // Ignore localStorage write failures.
  }
};

export const clearCachedPricingPermission = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.removeItem(PRICING_PERMISSION_CACHE_KEY);
  } catch (error) {
    // Ignore localStorage cleanup failures.
  }
};
